import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["grid", "list", "gridBtn", "listBtn"];

  connect() {
    const view = localStorage.getItem("videos_layout") || "grid";
    this.applyView(view);
  }

  showGrid() {
    this.applyView("grid");
  }

  showList() {
    this.applyView("list");
  }

  applyView(view) {
    localStorage.setItem("videos_layout", view);
    const isGrid = view === "grid";

    this.gridTarget.classList.toggle("hidden", !isGrid);
    this.listTarget.classList.toggle("hidden", isGrid);

    if (this.hasGridBtnTarget) {
      this.gridBtnTarget.classList.toggle("btn-active", isGrid);
    }
    if (this.hasListBtnTarget) {
      this.listBtnTarget.classList.toggle("btn-active", !isGrid);
    }
  }
}
